import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import OpalTile from '../../../opal/OpalTile'
import AdminPage from '../../admin/shared/AdminPage'
import FlexRow from '../../../molecules/FlexRow'

function DataHomeIndexView ({ root }) {
  return (
    <AdminPage>
      <FlexRow className='items-center justify-center' style={{ flexWrap: 'wrap' }}>
        <Link to={`${root}/integrator`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Integrator
          </OpalTile>
        </Link>
        <Link to={`${root}/ingestion`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Ingestion
          </OpalTile>
        </Link>
        <Link to={`${root}/analysis`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Analysis
          </OpalTile>
        </Link>
        <Link to={`${root}/alerts`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Alerts
          </OpalTile>
        </Link>
        <Link to={`${root}/orchestration`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Orchestration
          </OpalTile>
        </Link>
        <Link to={`${root}/catalog`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Denali Data Catalog
          </OpalTile>
        </Link>
        <Link to={`${root}/orion-system`}>
          <OpalTile size='xl' className='opal-selectable font-size-lg text-center p-sm'>
            Orion System Integration
          </OpalTile>
        </Link>
      </FlexRow>
    </AdminPage>
  )
}

DataHomeIndexView.propTypes = {
  root: PropTypes.any
}

export default DataHomeIndexView
